<script>
import { mapGetters } from 'vuex'

export default {
    name: 'MenuSubmenu',

    props: {
        icon: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        }
    },

    computed: {
        ...mapGetters(['currentUser']),

        visibleItems() {
            return this.items.filter(item =>
                !item.permission || this.hasPermission(item.permission)
            )
        }
    },

    methods: {
        hasPermission(permission) {
            return this.currentUser?.user?.permission?.includes(permission)
        },

        getVisibleChildren(children) {
            if (!children) return []
            return children.filter(child =>
                !child.permission || this.hasPermission(child.permission)
            )
        },

        menuItemClasses(isActive, isExactActive) {
            return {
                'menu-item-active': isActive || isExactActive
            }
        }
    }
}
</script>


<template>
    <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item menu-item-submenu"
    >
        <a href="#" class="menu-link menu-toggle">
            <i class="menu-icon" :class="icon"></i>
            <span class="menu-text">{{ text }}</span>
            <i class="menu-arrow"></i>
        </a>

        <div class="menu-submenu menu-submenu-classic menu-submenu-right">
            <ul class="menu-subnav">
                <template v-for="item in visibleItems" >
                    <li
                        v-if="item.children"
                        aria-haspopup="true"
                        data-menu-toggle="hover"
                        class="menu-item"
                    >
                        <a href="#" class="menu-link menu-toggle">
                            <i class="menu-bullet menu-bullet-dot"><span></span></i>
                            <span class="menu-text">{{ item.text }}</span>
                            <i class="menu-arrow"></i>
                        </a>

                        <div class="menu-submenu menu-submenu-classic menu-submenu-right">
                            <ul class="menu-subnav">
                                <router-link
                                    v-for="childItem in getVisibleChildren(item.children)"
                                    :key="childItem.name"
                                    :to="{ name: childItem.name }"
                                    v-slot="{ href, navigate, isActive, isExactActive }"
                                >
                                    <li
                                        aria-haspopup="true"
                                        data-menu-toggle="hover"
                                        class="menu-item"
                                        :class="menuItemClasses(isActive, isExactActive)"
                                    >
                                        <a :href="href" class="menu-link" @click="navigate">
                                            <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                            <span class="menu-text">{{ childItem.text }}</span>
                                        </a>
                                    </li>
                                </router-link>
                            </ul>
                        </div>
                    </li>

                    <!-- Regular menu item -->
                    <router-link
                        v-else
                        :to="{ name: item.name }"
                        v-slot="{ href, navigate, isActive, isExactActive }"
                    >
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="menuItemClasses(isActive, isExactActive)"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-bullet menu-bullet-dot"><span></span></i>
                                <span class="menu-text">{{ item.text }}</span>
                            </a>
                        </li>
                    </router-link>
                </template>
            </ul>
        </div>
    </li>
</template>

<style scoped>

</style>